<template>
  <div class="anouncemnet-list">
    <div id="div-with-loading1" class="vs-con-loading__container">
      <Spin size="large" fix v-if="loading"></Spin>

      <Row v-if="!loading && data.length === 0" type="flex" justify="center">
        <Col :span="24">
          <img
            style="width: 180px"
            src="@/assets/img/no-data.png"
            alt="no-data"
          />
        </Col>
        <Col>
          <p class="b-10">{{ $t('i.table.noDataText') }}</p>
        </Col>
      </Row>
      <template v-if="!loading && data.length > 0">
        <Row
          class="row"
          v-for="(v, i) in data"
          :key="i"
          @click.native="$router.push(`/policies/${v.id}/show`)"
        >
          <Row class="title">{{ v.title }}</Row>
          <Row algin="center" type="flex" justify="space-between">
            <div>
              <span class="text">
                {{ $moment(`${v.publishAt}Z`).format('YYYY-MM-DD HH:mm') }}
              </span>
            </div>
          </Row>
        </Row>
      </template>
    </div>

    <Row justify="center" class="mt-25" vs-align="center" v-if="totalPages > 1">
      <Page
        :total="totalElements"
        :current="filters.current + 1"
        :page-size="filters.size"
        @on-change="changPage($event, 'current')"
      />
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: null,
      totalElements: 0,
      totalPages: 0,
      page: 0,
      data: [],
      filters: {
        current: 1,
        size: 8,
        search: null,
        status: 'PUBLISHED',
        allFlag: true
      }
    };
  },
  mounted() {
    this.init_data();
  },
  methods: {
    async init_data() {
      try {
        this.loading = true;
        const res = await this.$http(
          'get',
          `mobile/policies`,
          this.filters,
          true
        );
        this.data = res.data.records || [];
        this.totalElements = res.data.total;
        this.totalPage = res.data.pages;
        this.page = res.data.current;
        this.loading = false;
        console.log(res);
      } catch (e) {
        this.loading = false;
      }
    },
    changPage(val, type) {
      if (type === 'size') {
        this.filters['current'] = 1;
      }
      this.filters[type] = val;
      this.init_data();
    }
  }
};
</script>
<style lang="less" scoped>
.mt-25 {
  margin-top: 25px;
  margin-bottom: 25px;
}

.vs-pagination--mb {
  justify-content: center;
}

.row:hover {
  .title {
    opacity: 0.49;
  }
}

.row {
  box-shadow: 0px 1px 0px 0px #dee0e3;
  padding: 20px 0;
  cursor: pointer;

  .title {
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    color: #1f2329;
    line-height: 25px;
    margin-bottom: 8px;
  }

  .mr-32 {
    margin-right: 32px;
  }

  .ml_r-10 {
    margin: 0 10px;
    color: #858d99;
  }

  .text {
    font-size: 14px;
    color: #858d99;
    line-height: 16px;
  }
}
</style>
